import gsap from 'gsap'

import Site from 'stores/Site'
import Component from 'classes/Component'
import Select from 'components/Select'

export default class Form extends Component {
    constructor({el}) {
        super()

        this.el = el
        this.checkForm = this.checkFormLoaded.bind(this)
        this.hasLoaded = false

        gsap.ticker.add(this.checkForm)
    }

    init() {
        super.init()

        this.initFields()

        const handler = () => {
            this.onSubmit()
        }

        this.addEventHandler({
            el: this.el,
            event: 'wpcf7submit',
            handler
        })
    }

    checkFormLoaded() {
        if (wpcf7.init) {
            gsap.ticker.remove(this.checkForm)

            this.hasLoaded = true

            if (!Site.isFirstLoad) {
                wpcf7.init(this.el)
            }

            this.initSubmit()
            this.initCountry()
        }
    }

    initFields() {
        this.fields = []
        this.fieldWrappers = this.el.querySelectorAll('.wpcf7-form-control-wrap')

        this.fieldWrappers.forEach(el => {
            const field = el.querySelector('.wpcf7-form-control')

            if (field.classList.contains('wpcf7-submit') || field.classList.contains('wpcf7-file')) {
                return
            }

            let labelText = field.getAttribute('placeholder')
            const label = document.createElement('span')
            const labelInner = document.createElement('span')

            label.classList.add('field-label')
            labelInner.classList.add('field-label-inner')

            el.insertBefore(label, field)
            label.appendChild(labelInner)

            if (field.classList.contains('wpcf7-select')) {
                const select = new Select({
                    el: field
                })
                select.init()

                labelText = field.querySelectorAll('option')[0].textContent
            }

            labelInner.innerHTML = labelText

            const fieldChangeHandler = (e) => {
                this.onFieldChange(e)
            }

            const fieldFocusHandler = (e) => {
                this.onFieldFocus(e)
            }

            this.addEventHandler({
                el: field,
                event: 'change',
                handler: fieldChangeHandler
            })

            this.addEventHandler({
                el: field,
                event: 'blur',
                handler: fieldChangeHandler
            })

            this.addEventHandler({
                el: field,
                event: 'focus',
                handler: fieldFocusHandler
            })

            this.fields.push(field)
        })
    }

    initSubmit() {
        const submit = this.el.querySelector('.wpcf7-submit')
        const submitText = submit?.value || 'Submit'

        const wrapper = document.createElement('div')
        wrapper.classList.add('submit-wrapper')

        const spinner = document.createElement('div')
        spinner.classList.add('loading-spinner')
        spinner.innerHTML = '<div></div><div></div><div></div><div></div>'

        const button = document.createElement('button')
        button.type = 'submit'
        button.className = 'btn btn-primary wpcf7-form-control has-spinner wpcf7-submit'
        button.innerHTML = `
                <span class="btn-fill"></span>
                <span class="btn-text-wrapper"><span class="btn-text">${submitText}</span><span class="btn-text-hover">${submitText}</span></span>
          `

        submit.parentNode.insertBefore(wrapper, submit)
        wrapper.appendChild(button)
        wrapper.appendChild(spinner)
        submit.remove()
    }

    onFieldChange(e) {
        const field = e.target
        const parent = field.closest('.wpcf7-form-control-wrap')

        if (field.value) {
            parent.classList.add('has-value')
        } else {
            parent.classList.remove('has-value')
        }

        if (field.classList.contains('wpcf7-not-valid')) {
            parent.classList.add('not-valid')
        } else {
            parent.classList.remove('not-valid')
        }
    }

    onFieldFocus(e) {
        const field = e.target
        const parent = field.closest('.wpcf7-form-control-wrap')

        parent.classList.add('has-value')
    }

    onSubmit() {
        if (!this.el.classList.contains('invalid') && !this.el.classList.contains('failed')) {
            const toast = this.el.querySelector('.wpcf7-response-output')

            this.el.querySelectorAll('.has-value').forEach(el => {
                el.classList.remove('has-value')
            })

            Site.ctx(()=> {
                gsap.to(toast, {
                    autoAlpha: 0,
                    delay: 3,
                    onComplete: () => {
                        this.resetForm()

                        gsap.set(toast, {
                            autoAlpha: 1
                        })
                    }
                })
            })
        } else {
            setTimeout(()=> {
                this.fields.forEach(el => {
                    if (el.classList.contains('wpcf7-not-valid')) {
                        el.closest('.wpcf7-form-control-wrap').classList.add('not-valid')
                    }
                })
            }, 50)
        }
    }

    initCountry() {
        const countryField = this.el.querySelector('.wpcf7-form-control-wrap[data-name="field-country"]')

        if (!countryField) return

        const option = countryField.querySelector('.select-option[data-value="South Africa"]')

        if (!option) return

        option.dispatchEvent(new Event('click'))
    }

    resetForm() {
        try {
            wpcf7.reset(this.el)
        } catch (ev) {
            wpcf7.init(this.el)
        }
    }

    pageLoaded() {
        super.pageLoaded()
    }

    update() {
        super.update()
    }

    resize() {
        super.resize()
    }

    destroy() {
        super.destroy()

        if (!this.hasLoaded && this.checkForm) {
            gsap.ticker.remove(this.checkForm)
        }
    }
}